
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/job-seekers/submission-success",
      function () {
        return require("private-next-pages/us/job-seekers/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/job-seekers/submission-success"])
      });
    }
  